import React from "react";
import { Box, Table, TableBody, TableCell, TableContainer, TableRow, Checkbox, Radio, TextField, Paper, FormControlLabel } from "@mui/material";
import Lineinput from "../../../common/lineinput";
import { bookingEventConfigData, bookingEventConfigDataForOfflineBooking, cellStyles, defPaymentType } from "./Constant";
import DropDownOA from "../../../common/dropDownOA";

const renderField = (type, fieldKey, style = {}, editSaveData, setEditSaveData, radioValue) => {
    const handleChange = (newValue) => {
        if (fieldKey === 'IsBookingBranchUserForOfflineBkng') {
            setEditSaveData(prev => ({
                ...prev,
                ['IsLoggedInUserForOfflineBooking']: radioValue
            }));
        } else if (fieldKey === 'IsLoggedInUserForOfflineBooking') {
            setEditSaveData(prev => ({
                ...prev,
                ['IsBookingBranchUserForOfflineBkng']: radioValue
            }));
        }
        setEditSaveData(prev => ({
            ...prev,
            [fieldKey]: newValue
        }));
    };

    const fieldValue = editSaveData?.[fieldKey];

    switch (type) {
        case "checkbox":
            return (
                <Checkbox
                    checked={fieldValue === 1 || fieldValue === true}
                    onChange={(e) => handleChange(e.target.checked ? 1 : 0)}
                    sx={{
                        fontSize: '12px',
                        backgroundColor: 'transparent !important',
                        height: '36px',
                        verticalAlign: 'middle',
                        ...style,
                    }}
                />
            );

        case "radio":
            return (
                <Radio
                    checked={fieldValue === radioValue}
                    onChange={() => handleChange(radioValue)} // assumes selecting this radio sets the value
                    name={fieldKey}
                    sx={{ ...style }}
                />
            );

        case "text":
            return (
                <Box className="inputBox">
                    <div
                        className={'input--wrapper'}
                        style={{
                            width: '100%',
                            marginBottom: '0px'
                        }}
                    >
                        <Lineinput
                            value={fieldValue || ''}
                            onChange={(e) => handleChange(e.target.value)}
                            disabled={fieldKey === 'isDisable'}
                        />
                    </div>
                </Box>
            );

        case "DropDown":
            return (
                <DropDownOA
                    label={''}
                    id={'status'}
                    data={defPaymentType || []}
                    defaultvalue={editSaveData.defaultPayType}
                    // value={editSaveData.macDrop}
                    onSelect={(val) => {
                        setEditSaveData((prev) => ({
                            ...prev,
                            DefaultPaymentType: val.id,
                        }));
                    }}
                    noCross={true}
                    idKey={`id`}
                    dataKey={`name`}
                    minWidth="200px"
                    nextId={'loadBtn'}
                />
            );

        default:
            return null;
    }
};

const BookingEventConfig = (props) => {
    const { setEditSaveData, editSaveData, handleBrnhCargoValue } = props
    return (
        <>
            <Box sx={{ width: "100%" }}>
                <TableContainer component={Paper} sx={{ display: 'flex', borderRight: '1px solid #DAEDFE', width: '100%', overflow: 'visible' }} className="scrollBlue">
                    <Table stickyHeader size="small" style={{ width: '50%', borderRight: '1px solid #d9d9d9' }}>
                        <TableBody>
                            {bookingEventConfigData.map((section, sectionIdx) => (
                                <React.Fragment key={`section-${sectionIdx}`}>
                                    <TableRow>
                                        <TableCell colSpan={4} sx={{ background: "#DAEDFE", fontWeight: '700', padding: '7px 12px', fontSize: '12px', color: '#444444', fontFamily: 'Roboto' }}>
                                            {section.section}
                                        </TableCell>
                                    </TableRow>
                                    {section.rows.map((row, rowIdx) => (
                                        <TableRow key={`row-${sectionIdx}-${rowIdx}`}>
                                            {/* Left Side */}
                                            <TableCell style={{ ...cellStyles,...row.leftStyle, width: '25%', padding: '7px 12px', fontSize: '12px', color: '#444444', fontFamily: 'Roboto', }}>
                                                {row.leftLabel}
                                            </TableCell>
                                            <TableCell sx={{ textAlign: "center",...cellStyles, ...row.leftStyle, width: "25%", padding: '7px 12px', fontSize: '12px', color: '#444444', fontFamily: 'Roboto' }} >
                                                {renderField(row.leftType, row.leftValue, row.leftStyle, editSaveData, setEditSaveData, row.leftRadioValue)}
                                            </TableCell>
                                            {/* Right Side */}
                                            <TableCell sx={{ ...cellStyles,width: "25% !important", padding: '7px 12px', fontSize: '12px', color: '#444444', fontFamily: 'Roboto' }}>
                                                {row.rightLabel}
                                            </TableCell>
                                            <TableCell sx={{ ...cellStyles,textAlign: "center", ...row.rightStyle, width: "25%", padding: '7px 12px', fontSize: '12px', color: '#444444', fontFamily: 'Roboto' }}>
                                                {renderField(row.rightType, row.rightValue, row.rightStyle, editSaveData, setEditSaveData, row.rightRadioValue)}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </React.Fragment>
                            ))}
                        </TableBody>
                    </Table>
                    <Table size="small" style={{ width: '50%' }}>
                        <TableBody>
                            {bookingEventConfigDataForOfflineBooking.map((section, sectionIdx) => (
                                <React.Fragment key={`section-${sectionIdx}`}>
                                    <TableRow>
                                        <TableCell colSpan={4} sx={{ background: "#DAEDFE", fontWeight: '600', padding: '7px 12px', fontSize: '12px', color: '#444444', fontFamily: 'Roboto' }}>
                                            {section.section}
                                        </TableCell>
                                    </TableRow>

                                    {section.rows.map((row, rowIdx) => (
                                        <TableRow key={`row-${sectionIdx}-${rowIdx}`}>
                                            {/* Left Side */}
                                            <TableCell style={{ ...cellStyles,width: '35%', padding: '7px 12px', fontSize: '12px', color: '#444444', fontFamily: 'Roboto',fontWeight:row.leftLabel==="STICKER USE TYPE" || row.leftLabel==="STICKER COPIES"?'bold':'500' }}>
                                                {row.leftLabel}
                                            </TableCell>
                                            <TableCell sx={{ ...cellStyles,...row.leftStyle, width: '25%', padding: '7px 12px', fontSize: '12px', color: '#444444', fontFamily: 'Roboto', textAlign: "center" }}>
                                                <span style={{ display: 'flex' }}>
                                                    <span>
                                                        {row.leftValue === 'MinGoodsValue' && (
                                                            <Checkbox
                                                                checked={!!editSaveData?.IsMinimumGoodsValue}
                                                                onChange={(e) =>
                                                                    setEditSaveData((prev) => ({
                                                                        ...prev,
                                                                        IsMinimumGoodsValue: e.target.checked
                                                                    }))
                                                                }
                                                                size="small"
                                                                sx={{
                                                                    fontSize: '12px',
                                                                    backgroundColor: 'transparent !important',
                                                                    height: '36px',
                                                                    verticalAlign: 'middle',
                                                                }}
                                                            />
                                                        )}
                                                    </span>
                                                    <span>
                                                        {renderField(row.leftType, row.leftValue, row.leftStyle, editSaveData, setEditSaveData, row.leftRadioValue)}
                                                    </span>

                                                </span>
                                            </TableCell>
                                            {/* Right Side */}
                                            <TableCell style={{ ...cellStyles,width: '25%', padding: '7px 12px', fontSize: '12px', color: '#444444', fontFamily: 'Roboto' }}>
                                                {row.rightLabel}
                                            </TableCell>
                                            <TableCell sx={{ width: '25%', textAlign: "center", ...row.rightStyle, padding: '7px 12px', fontSize: '12px', color: '#444444', fontFamily: 'Roboto' }}>
                                                <span style={{ display: 'flex' }}>
                                                    <span>
                                                        {row.rightValue === 'MinQrAmount' && (
                                                            <Checkbox
                                                                checked={!!editSaveData?.IsQRRechargeAmount}
                                                                onChange={(e) =>
                                                                    setEditSaveData((prev) => ({
                                                                        ...prev,
                                                                        IsQRRechargeAmount: e.target.checked
                                                                    }))
                                                                }
                                                                size="small"
                                                                sx={{
                                                                    fontSize: '12px',
                                                                    backgroundColor: 'transparent !important',
                                                                    height: '36px',
                                                                    verticalAlign: 'middle',
                                                                }}
                                                            />
                                                        )}
                                                    </span>
                                                    <span>
                                                        {renderField(row.rightType, row.rightValue, row.rightStyle, editSaveData, setEditSaveData, row.rightRadioValue)}
                                                    </span>

                                                </span>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </React.Fragment>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </>
    )
}

export default BookingEventConfig